"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagDescription = void 0;
const utils_1 = require("../utils");
exports.TagDescription = () => {
    return {
        Tag(tag, ctx) {
            utils_1.validateDefinedAndNonEmpty('description', tag, ctx);
        },
    };
};
